// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo{width:4rem;opacity:1;transition:opacity .15s ease-in-out}.logo path{fill:#fff}.logo:hover{cursor:pointer;opacity:.7}", ""]);
// Exports
module.exports = exports;
